import { BasketItem, BasketTotal } from 'components/BasketPage/BasketMain/types';
import apiRequest from './apiRequest';
import endpoints from './endpoints';
import { HttpMethods } from './types';
import itemsMock from './mockups/cart-with-totals.json';
import itemMock from './mockups/individual-item.json';
import totalMock from './mockups/totals-api-response.json';
import deliveryMock from './mockups/get-delivery-info.json';
import quantitySelectorMock from './mockups/selectors/get-selectors-quantities.json';
import framesSelectorMock from './mockups/selectors/get-selectors-frames.json';
import mugSizeSelectorMock from './mockups/selectors/get-selectors-op-mug-size.json';
import mugTypeSelectorMock from './mockups/selectors/get-selectors-op-mug-type.json';
import mugPrintAreaSelectorMock from './mockups/selectors/get-selectors-mug-print-area.json';
import mugColorSelectorMock from './mockups/selectors/get-selectors-mug-color.json';

function mockApiResponse<T>(jsonResponse: any, path = 'data') {
  return new Promise((resolve, reject) => {
    resolve(jsonResponse[path] as T);
  });
}

function delay(timeout: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
}
async function fetchBasketTotal() {
  return mockApiResponse<BasketTotal>(totalMock);
}

async function fetchBasketItem(orderItemId: number) {
  return mockApiResponse(itemMock);
}

async function removeBasketItem(orderItemId: number) {
  try {
    await apiRequest(
      endpoints.cartV1ItemRemove,
      {
        orderItemId,
      },
      HttpMethods.POST,
      'data',
    );
  } catch (e) {
    return false;
  }
  return true;
}

async function fetchBasketDelivery() {
  return mockApiResponse<DelayOptions>(deliveryMock);
}

async function fetchBasketItems() {
  return mockApiResponse<BasketItem[]>(itemsMock);
}

async function applyVoucherCode(code: string) {
  try {
    await apiRequest(
      endpoints.cartV1VoucherAdd,
      {
        code,
      },
      HttpMethods.POST,
      'data',
    );
  } catch (e) {
    return false;
  }
  return true;
}

async function removeVoucherCode(voucherId: number) {
  try {
    await apiRequest(
      endpoints.cartV1VoucherRemove,
      {
        voucherId,
      },
      HttpMethods.POST,
      'data',
    );
  } catch (e) {
    return false;
  }
  return true;
}

async function changeSelectorValue(orderItemId: number, typeName: string, value: any) {
  // await apiRequest();
}

async function fetchSeletorOptions(orderItemId: number, typeName: string) {
  switch (typeName) {
    case 'OpProductQuantity':
      return mockApiResponse(quantitySelectorMock);
    case 'OpProductFrames':
      return mockApiResponse(framesSelectorMock);
    case 'OpMugColor':
      return mockApiResponse(mugColorSelectorMock);
    case 'OpMugSize':
      return mockApiResponse(mugSizeSelectorMock);
    case 'OpMugType':
      return mockApiResponse(mugTypeSelectorMock);
    case 'OpMugPrintArea':
      return mockApiResponse(mugPrintAreaSelectorMock);
    default:
      return mockApiResponse(quantitySelectorMock);
  }
}

const basketApi = {
  fetchBasketTotal,
  fetchBasketItems,
  fetchBasketItem,
  fetchBasketDelivery,
  removeBasketItem,
  applyVoucherCode,
  removeVoucherCode,
  changeSelectorValue,
  fetchSeletorOptions,
  delay,
};

export default basketApi;
